(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ds-delivery-fit')) {
  customElements.define('ds-delivery-fit', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.fit()); };
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this);
      this.changes = new MutationObserver(this.schedule);
      this.changes.observe(this, { childList: true, subtree: true, characterData: true });
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    fit() {
      const text = this.querySelector('p');
      if (!text || !text.clientWidth) return;
      const available = text.clientWidth;
      text.style.setProperty('--ds-delivery-font', '14px');
      const range = document.createRange();
      range.selectNodeContents(text);
      const needed = range.getBoundingClientRect().width;
      if (needed > available) text.style.setProperty('--ds-delivery-font', `${Math.floor(14 * available / needed * 100) / 100}px`);
    }
    disconnectedCallback() { this.resize?.disconnect(); this.changes?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
